import { bathingGridConfig } from "@core/configs/bathing-header.config";
import { SESSION_STORAGE_KEY } from "@core/configs/local-storage-key.config";
import { BathingScreenSortType } from "@core/constants/enum.common";
import { Utils } from "@core/helper/utils.helper";


export class LayoutConfig {
    timeChangeGridPageInMs: number;
    unitSelectedKey: string[];
    groupSelectedKey: string[];
    bathRoomSelectedKey: string;
    displayColumnAliases: string[];
    isFlashingMoshiokuri: boolean;
    sortType: BathingScreenSortType;

    constructor() {
        this.timeChangeGridPageInMs = 30000;
        this.sortType = BathingScreenSortType.BY_BATH_ORDER;
        this.unitSelectedKey = [];
        this.groupSelectedKey = [];
        this.bathRoomSelectedKey = "";
        this.displayColumnAliases = bathingGridConfig.header
            .filter((h: any) => h.visible !== false)
            .map((h: any) => h.field);
        this.isFlashingMoshiokuri = true;
    }
}
export class BathingScreenSetting extends LayoutConfig {
    currentPage: number;
    lockPage: number;
    totalPage: number;
    pageSize: number;

    constructor() {
        super();
        this.currentPage = 1;
        this.lockPage = -1;
        this.totalPage = 0;
        this.pageSize = 10;
    }

    toLayoutConfig(): LayoutConfig {
        const layout = new LayoutConfig();
        layout.timeChangeGridPageInMs = this.timeChangeGridPageInMs;
        layout.unitSelectedKey = this.unitSelectedKey;
        layout.groupSelectedKey = this.groupSelectedKey;
        layout.bathRoomSelectedKey = this.bathRoomSelectedKey;
        layout.displayColumnAliases = [...this.displayColumnAliases];
        layout.isFlashingMoshiokuri = this.isFlashingMoshiokuri;
        layout.sortType = this.sortType;
        return layout;
    }

    updateFromLayoutConfig(config: LayoutConfig): void {
        this.timeChangeGridPageInMs = config.timeChangeGridPageInMs;
        this.unitSelectedKey = config.unitSelectedKey;
        this.groupSelectedKey = config.groupSelectedKey;
        this.bathRoomSelectedKey = config.bathRoomSelectedKey;
        this.displayColumnAliases = [...config.displayColumnAliases];
        this.isFlashingMoshiokuri = config.isFlashingMoshiokuri;
        this.sortType = config.sortType;
    }
}
